import React, { useState } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { Modal, Button, Col, Form, Row, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import fr from 'date-fns/locale/fr';
import { useEffect } from 'react';
import Newucrm from '../crm/New';


const NewBooking = () => {
    registerLocale('fr', fr);
    setDefaultLocale('fr');

    const [showModal, setShowModal] = useState(false);
    const [valueClientId, setValueClientId] = React.useState(null);
    const [valueVilla, setValueVilla] = React.useState(null);
    const [valueStatut, setValueStatut] = React.useState(null);
    const [valueListDemande, setValueListDemande] = React.useState([]);
    const [valueDemande, setValueDemande] = React.useState(null);
    const [valueOrigin, setValueOrigin] = React.useState(null);
    const [validated, setValidated] = React.useState(false);
    const [formd, setFrom] = React.useState({});
    const [l, setL] = React.useState(false);
    const [is_moral, setMoral] = React.useState(false);
    const [is_owner, setIs_Owner] = React.useState(false);
    const [clients, setClients] = React.useState([]);
    const [checkIn, setCheckIn] = React.useState(null);
    const [checkOut, setCheckOut] = React.useState(null);
    const [booked_date, setBooked_Date] = React.useState(new Date());
    const [demand_date, setDemand_Date] = React.useState(new Date());
    const [emails, setEmails] = React.useState('');
    const [villas, setVilla] = React.useState([]);

    const navigate = useNavigate();

    const getDemands = () => {

        firebase.firestore().collection(`demands`)
            .get().then((ls) => {
                let s = [];
                ls.forEach((d) => {
                    let e = d.data()
                    e.id = d.id;
                    if (e?.delete === true) {

                    } else {
                        s.push({ value: d.id, label: `N° ${e?.origin_id} - ${e?.client?.label} - ${e?.property?.label} (${e?.statut?.label})` })
                    }
                })
                setValueListDemande(s);
            }).catch((error) => {
                setL(false);
                var errorMessage = error.message;
                toast.error(errorMessage);
            })
    }

    const loadVilla = () => {
        firebase.firestore().collection('properties').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                var l = d.data();
                if (l?.delete) {
                    // supprimer donc ne pas affiché
                } else {
                    const dr = { value: d.id, label: `${l?.nameHouse}`, roomsNbr: Number(l.nbRooms) }
                    s.push(dr)
                }

            })
            setVilla(s);
        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
    }



    const getClients = () => {
        // get list clients and format
        firebase.firestore().collection('crm').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                let pre = d.data()?.email?.split(',') || []
                pre.forEach((s) => {
                    e += `${s}, `;
                })
                const dr = { value: d.id, label: `${d.data()?.lastName} ${d.data()?.firstName}`, email: e }
                if (d.data()?.delete) { }
                else {
                    s.push(dr)
                }
            })
            setClients(s);
        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

    }

    useEffect(() => {
        getClients();
        loadVilla();
        getDemands();
    }, []);

    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        console.log(formd)
        if (form.checkValidity() === false) {
            return;
        }

        if (l) {
            return;
        }

        var t = formd
        t.checkin = checkIn;
        t.checkout = checkOut;
        t.booked_date = new Date();
        t._create_At = new Date();
        t._update_At = new Date();
        t.booked_date = booked_date;
        t.guest = {
            firstName: t?.client?.label.split(' ')[1],
            lastName: t?.client?.label.split(' ')[0]
        }
        let dds = t?.email?.split(',');
        let sd = []
        dds?.forEach(s => {
            if (validateEmail(s?.trim())) {
                sd.push(s?.trim());
            }
        })
        t.emails = sd;


        console.log(t)



        setValidated(true);
        setL(true);
        let al = t.email
        // delete t.email;
        try {
            firebase.firestore().collection('bookings').add(t).then(() => {
                console.log("Document successfully written!");
                toast.success("Réservation créer avec succès");
                navigate('/bookings');
            }).catch((error) => {
                setL(false);
                var errorMessage = error.message;
                toast.error(errorMessage);
                t.email = al
            })
        } catch (error) {
            setL(false);
            t.email = al
            var errorMessage = error.message;
            toast.error(errorMessage);
        }

    };


    const handleChange = e => {
        let d = formd;
        // console.log(e.target.name, e.target?.checked,e.target?.value ); 
        if (e.target.name === "is_owner") {
            d[e.target.name] = e.target.checked;
            setIs_Owner(e.target.checked)
        } else {
            if (e.target.name === "type") {
                d[e.target.name] = e.target.value === "moral" ? "moral" : "physique";
                setMoral(e.target.value === "moral")
            } else {
                d[e.target.name] = e.target.value;
                if (e.target.name === "email") {
                    setEmails(e.target.value)
                }
            }
        }

        setFrom(d);
    };


    return (
        <FalconComponentCard>
            <FalconComponentCard.Header title="Nouvelle réservation" light={false} noPreview={true} />
            <FalconComponentCard.Body >
                <Form noValidate validated={validated} onSubmit={handleSubmit}>

                    <Row className="mb-3">
                        <Form.Group as={Col} md="5" controlId="bookingorder">
                            <Form.Label>Client</Form.Label>
                            <Select
                                required
                                closeMenuOnSelect={false}
                                options={clients}
                                placeholder={clients.length === 0 ? 'Chargement...' : 'Choisir le client...'}
                                classNamePrefix="react-select"
                                value={valueClientId}
                                onChange={value => {
                                    let d = formd;
                                    d['client'] = value;
                                    setFrom(d);
                                    if (valueClientId?.value !== value.value) {
                                        // si changement de client on efface email et on réinit
                                        let f = formd
                                        f['email'] = undefined;
                                        setFrom(f);
                                        setEmails('')
                                    }
                                    setValueClientId(value)
                                    if (formd['email'] === undefined) {
                                        let id = value.value
                                        clients.forEach(d => {
                                            if (d?.value === id) {
                                                let f = formd
                                                f['email'] = d.email
                                                setFrom(f);
                                                setEmails(d.email)
                                            }
                                        })
                                    }

                                }
                                }
                            />
                            {formd && formd.client === undefined && <p><a href={`#`} onClick={() => setShowModal(true)}  >Nouveau client</a></p>}

                        </Form.Group>
                        <Form.Group as={Col} md="5" controlId="villa">
                            <Form.Label>Propriété</Form.Label>
                            <Select
                                required
                                options={villas}
                                placeholder='Choisir la villa...'
                                classNamePrefix="react-select"
                                value={valueVilla}
                                onChange={value => {
                                    setValueVilla(value)
                                    let d = formd;
                                    d['property'] = value;
                                    d['roomsNbr'] = value?.roomsNbr;
                                    setFrom(d);

                                }}
                            />
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md="5" controlId="bookingorder">
                            <Form.Label>Statut de la réservation</Form.Label>
                            <Select
                                closeMenuOnSelect={false}
                                required
                                options={[
                                    { value: 'canceled', label: 'Annuler' },
                                    // { value: 'created', label: 'En cours' },  
                                    { value: 'confirmed', label: 'Confirmé' },
                                    // { value: 'pay_attented', label: 'En attente de paiement' },  
                                ]}
                                placeholder='Choisir le statut...'
                                classNamePrefix="react-select"
                                value={valueStatut}
                                onChange={value => {
                                    setValueStatut(value)

                                    let d = formd;
                                    d['statut'] = value;
                                    setFrom(d);

                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="5" controlId="bookingorder">
                            <Form.Label>Origine de la réservation</Form.Label>
                            <Select
                                closeMenuOnSelect={false}
                                options={[
                                    { value: 'direct', label: 'Direct' },
                                    { value: 'airbnb', label: 'AirBnb' },
                                    { value: 'abritel', label: 'Abritel' },
                                    { value: 'tripadvisor', label: 'Tripadvisor' },
                                    { value: 'locasun', label: 'Locasun' },
                                    { value: 'expedia', label: 'Expedia' },
                                    { value: 'homeToGo', label: 'HomeToGo' },
                                    { value: 'kayak', label: 'Kayak' },
                                    { value: 'homerez', label: 'Homerez' },
                                    { value: 'booking', label: 'Booking' },
                                    { value: 'website', label: 'Site Internet' },
                                    { value: 'partner', label: 'Partenaire' },
                                ]}
                                placeholder="Choisir l'origine..."
                                classNamePrefix="react-select"
                                value={valueOrigin}
                                onChange={value => {
                                    setValueOrigin(value)


                                    let d = formd;
                                    d['origin'] = value;
                                    setFrom(d);

                                }}
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="4" controlId="originid">
                            <Form.Label>Numéro de réservation interne (id origin)</Form.Label>
                            <Form.Control
                                type="text"
                                name="origin_id"
                                onChange={handleChange}
                                placeholder="Identifiant interne"
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="4" controlId="originid">
                            <Form.Label>Numéro de commande (aibnb, booking, ...)</Form.Label>
                            <Form.Control
                                type="text"
                                name="number_booking"
                                onChange={handleChange}
                                placeholder="Numéro de commande..."
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="4" controlId="total_pay">
                            <Form.Label>Prix total payée (en €)</Form.Label>
                            <Form.Control
                                type="text"
                                name="total_pay"
                                onChange={handleChange}
                                placeholder="Tarif total de la réservation (ex: 590.90)"
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="4" controlId="adultNbr">
                            <Form.Label>Nombre total d'adulte</Form.Label>
                            <Form.Control
                                type="number"
                                name="adultNbr"
                                onChange={handleChange}
                                placeholder="Nombre total d'adulte"
                                min={1}
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="4" controlId="kidsNbr">
                            <Form.Label>Nombre total d'enfant</Form.Label>
                            <Form.Control
                                type="number"
                                name="kidsNbr"
                                onChange={handleChange}
                                placeholder="Nombre total d'enfant"
                                min={0}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="roomsNbr">
                            <Form.Label>Nombre total de chambre</Form.Label>
                            <Form.Control
                                type="number"
                                name="roomsNbr"
                                value={formd.roomsNbr}
                                onChange={handleChange}
                                placeholder="Nombre total de chambre"
                                min={0}
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="10" controlId="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="text"
                                name="email"
                                value={emails}
                                onChange={handleChange}
                                placeholder="Email du client "
                                required
                            />

                            <Form.Text className="text-warning fs--1">
                                Séparer par une virgule (ex: email@bohouse.com, email2@bohouse.com)
                            </Form.Text>
                        </Form.Group>

                        <Form.Group as={Col} md="3" controlId={`ScheduleStartDate`}>
                            <Form.Label>Check-in</Form.Label>

                            <DatePicker
                                showTimeSelect
                                dateFormat="dd/MM/yyyy HH:ss"
                                selected={checkIn}
                                startDate={checkIn}
                                endDate={checkOut}
                                timeFormat="p"
                                required
                                selectsStart
                                onChange={newDate => {
                                    let d = formd;
                                    d['checkin'] = newDate;
                                    setFrom(d)
                                    setCheckIn(newDate)
                                }}
                                customInput={
                                    <CustomDateInput
                                        formControlProps={{
                                            placeholder: 'jj/mm/yy',
                                            //     ...register(`ScheduleStartDate${index}`)
                                        }}
                                    />
                                }
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="3" controlId={`ScheduleEndDate`}>
                            <Form.Label>Check-out</Form.Label>

                            <DatePicker
                                selected={checkOut}
                                showTimeSelect
                                minDate={checkIn}
                                selectsEnd
                                required
                                startDate={checkIn}
                                endDate={checkOut}
                                dateFormat="dd/MM/yyyy HH:ss"
                                onChange={newDate => {
                                    let d = formd;
                                    d['checkout'] = newDate;
                                    setFrom(d)
                                    setCheckOut(newDate)
                                }}
                                customInput={
                                    <CustomDateInput
                                        formControlProps={{
                                            placeholder: 'jj/mm/yy',
                                            //     ...register(`ScheduleStartDate${index}`)
                                        }}
                                    />
                                }
                            />
                        </Form.Group>
                        <hr className="mt-3" />


                        <Form.Group as={Col} md="3" controlId={`booked_date`}>
                            <Form.Label>Date de la réservation</Form.Label>

                            <DatePicker
                                selected={booked_date}
                                dateFormat="dd/MM/yyyy"
                                onChange={newDate => {
                                    let d = formd;
                                    d['booked_date'] = newDate;
                                    setFrom(d)
                                    setBooked_Date(newDate)
                                }}
                                customInput={
                                    <CustomDateInput
                                        formControlProps={{
                                            placeholder: 'jj/mm/yy',
                                            //     ...register(`ScheduleStartDate${index}`)
                                        }}
                                    />
                                }
                            />
                        </Form.Group>
                        <hr className="mt-3" />

                        {/* <Form.Label>Information sur la demande</Form.Label>  */}

                        <Row className="mb-3">
                            <Form.Group as={Col} md="5" controlId="bookingorder">
                                <Form.Label>Numéro de demande</Form.Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    options={valueListDemande}
                                    placeholder='Choisir la demande lié...'
                                    classNamePrefix="react-select"
                                    value={valueDemande}
                                    onChange={value => {
                                        setValueDemande(value)

                                        let d = formd;
                                        d['numberDemand'] = value;
                                        setFrom(d);

                                    }}
                                />
                                {
                                    valueDemande?.value && (<p><a href={`/demand/edit/${valueDemande?.value}`} target="_blank">Afficher la demande sélectionnée</a></p>
                                    )
                                }

                            </Form.Group>

                            <Form.Group as={Col} md="5" controlId="demand_date">
                                <Form.Label> ou Date de la demande</Form.Label>
                                <DatePicker
                                    selected={demand_date}
                                    dateFormat="dd/MM/yyyy"
                                    onChange={newDate => {
                                        let d = formd;
                                        d['demand_date'] = newDate;
                                        setFrom(d)
                                        setDemand_Date(newDate)
                                    }}
                                    customInput={
                                        <CustomDateInput
                                            formControlProps={{
                                                placeholder: 'jj/mm/yy',
                                                //     ...register(`ScheduleStartDate${index}`)
                                            }}
                                        />
                                    }
                                />
                            </Form.Group>
                        </Row>


                        <hr className="mt-3" />
                        <Form.Label>Commentaire</Form.Label>
                        <Form.Group className="mb-3">

                            <Form.Control as="textarea" name="comment"
                                placeholder="Laisser un commentaire ici"
                                style={{ height: '100px' }}
                                onChange={handleChange}
                            />
                        </Form.Group>




                    </Row>

                    <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Créer'}</Button>
                </Form>

                {/* Modal d'ajout d'un nouveau client */}
                <Modal fullscreen show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Ajouter un nouveau client</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Newucrm canRedirect={false} redirectHere={(value) => {
                            let clientsm = clients
                            clientsm.push(value);

                            setClients(clientsm)
                            let d = formd;
                            d['client'] = value;
                            setFrom(d);
                            if (valueClientId?.value !== value.value) {
                                // si changement de client on efface email et on réinit
                                let f = formd
                                f['email'] = undefined;
                                setFrom(f);
                                setEmails('')
                            }
                            setValueClientId(value)
                            if (formd['email'] === undefined) {
                                let id = value.value
                                clientsm.forEach(d => {
                                    if (d?.value === id) {
                                        let f = formd
                                        f['email'] = d.email
                                        setFrom(f);
                                        setEmails(d.email)
                                    }
                                })
                            }
                            setShowModal(false)
                        }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Fermer
                        </Button>
                    </Modal.Footer>
                </Modal>
            </FalconComponentCard.Body>
        </FalconComponentCard>
    );
};

export default NewBooking;
